export default "__VITE_ASSET__BLg2YOs___"